// extracted by mini-css-extract-plugin
module.exports = {"search-container":"_32zog","search-box":"_2GXii","search-heading":"_3gsdT","query":"_2QfXM"};